import { EditorView } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
export const replaceWholeDoc = (editor, nextValue) => {
  editor === null || editor === void 0 ? void 0 : editor.dispatch({
    changes: {
      from: 0,
      to: editor.state.doc.length,
      insert: nextValue
    }
  });
};
export const createEditorView = (lastValueRef, extensions, onChangeRef, parent) => {
  return new EditorView({
    state: EditorState.create({
      extensions: [...(extensions || []), EditorView.updateListener.of(viewUpdate => {
        if (viewUpdate.view.destroyed) return;
        let texts = [undefined, undefined];

        if (viewUpdate.docChanged) {
          const next = viewUpdate.state.doc.toString();
          const prev = lastValueRef.current;
          lastValueRef.current = next;
          texts = [next, prev];
        }

        const onChange = onChangeRef === null || onChangeRef === void 0 ? void 0 : onChangeRef.current;

        if (!onChange) {
          return;
        }

        onChange(viewUpdate, texts[0], texts[1]);
      })],
      doc: lastValueRef.current
    }),
    parent: parent
  });
};